// import variant from "../variant/minimal";
import"./minimal.scss";import{Uploadfile}from"./olmoindex";// variant(".file");
export default function FormUploadfile(rootSelector){Uploadfile(rootSelector)}